import { solidstate } from ":setup/qstate";
import { Show } from "solid-js";
import Validate from "../components/validate";
import I18nSwitch from "../components/i18n-switch";
import ErrorPage from "../components/error-page";

//
import SideBG from "../assets/side-bg.svg";
import MOCLogo from "../assets/moc-logo.svg";

// const test = {
//   first_name: "easd",
//   last_name: "easd",
//   email: "test30@gmail.com",
//   attendance_status: false,
// };

type Props<T> = {
  api: (props: { email: string }) => Promise<T>;
  onValid: (details: T) => void;
  children: JSX.Element | JSX.Element[];
  debug?: boolean;
};
export default function DefaultLayout<T>(props: Props<T>) {
  const $validation_error = solidstate.create(null);
  const $valid = solidstate.create(false);
  return (
    <Show
      when={$validation_error.value == undefined}
      fallback={
        <ErrorPage
          error={$validation_error.value}
          onBack={() => {
            $validation_error.set(null);
          }}
        />
      }
    >
      <section class="grid grid-cols-[50%_50%] w-full h-full gap-2 <sm:(!flex flex-col)">
        <div class="grid grid-rows-[100px_1fr] w-full h-full px-38px py-2 gap-2 overflow-hidden <sm:(px-28px)">
          {/* logos */}
          <div class="grid grid-cols-[1fr_15%] items-center justify-center h-full gap-2 <sm:(flex flex-col)">
            <div class="grid grid-cols-[45%_45%] w-full h-full justify-start items-center gap-1 <sm:(!justify-center)">
              <img class="w-75% h-full" src="/logo.svg" alt="logo image" />
              <MOCLogo class="w-full h-full" />
            </div>
            <I18nSwitch />
          </div>
          {/* forms */}
          <div class="flex flex-col w-full h-full overflow-hidden">
            <Show
              when={$valid.value}
              fallback={
                <Validate
                  api={props.api}
                  onDone={({ details, error }) => {
                    if (error != undefined) {
                      $validation_error.set(error);
                      return;
                    }
                    props?.onValid?.(details);
                    $valid.set(true);
                  }}
                />
              }
            >
              {props.children}
            </Show>
          </div>
        </div>
        <div class="flex flex-col w-auto h-fit overflow-hidden <sm:(!hidden)">
          <SideBG class="w-full h-full" />
        </div>
      </section>
    </Show>
  );
}
